import { Layout } from 'components/index';
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { DashboardTabState } from 'types/enums/DashboardTabState';
import ToDoTab from './DashboardTabs/ToDoDashboard/ToDoTabScreen';
import KpiMetricsTab from './DashboardTabs/KpiMetricsTab';
import DashboardTabs from './DashboardTabs/DashboardTabs';
import TabContext from '@mui/lab/TabContext/TabContext';
import { useAppState } from 'store/Provider';
import TabPanel from '@mui/lab/TabPanel';
import moment from 'moment';

const startDate = moment().subtract(1, 'year').startOf('month').format('YYYY-MM-DD');
const endDate = moment().endOf('month').format('YYYY-MM-DD');

type Metric = { id: number; page_title: string };

const DashboardPage: React.FC<RouteComponentProps> = ({ match }) => {
  const { state } = useAppState();
  const [pendingStartDate, setPendingStartDate] = React.useState<string>(startDate);
  const [pendingEndDate, setPendingEndDate] = React.useState<string>(endDate);
  const [metric, setMetric] = React.useState<Metric | null>(null);

  return (
    <Layout name="Dashboard" path="" isWelcome>
      <TabContext value={state.dashboard.pageHandler.parentTab}>
        <DashboardTabs currentToAssignCount={0} />
        <TabPanel sx={{ p: 1 }} value={DashboardTabState.TODO}>
          <ToDoTab />
        </TabPanel>
        <TabPanel sx={{ p: 1 }} value={DashboardTabState.KPI_METRICS}>
          <KpiMetricsTab
            pendingStartDate={pendingStartDate}
            pendingEndDate={pendingEndDate}
            setPendingStartDate={setPendingStartDate}
            setPendingEndDate={setPendingEndDate}
            metric={metric}
            setMetric={setMetric}
          />
        </TabPanel>
      </TabContext>
    </Layout>
  );
};

export default DashboardPage;
